// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"de841934","5816":"b7916132","8960":"81fa512a","9019":"81fa512a"}[chunkId] + ".chunk.css";
};